import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ref, query, orderByKey, startAt, endAt, onValue } from "firebase/database";
import { FaArrowDown, FaArrowUp, FaFilter, FaSearch } from "react-icons/fa";
import { database } from "../firebaseConfig";
import { setLoading } from "../redux/slices/ui";
import { setEndDate, setFilters, setReports, setStartDate } from "../redux/slices/dailyReports";
import NoData from "../components/ui/NoData";
import { eur } from "../utils/format";
import PageHeader from "../components/ui/PageHeader";
import DateRangeForm from "../components/ui/DateRangeForm";
import List from "../components/dailyReports/List";
import AddDailyReport from "../components/dailyReports/AddDailyReport";

const DailyReports = () => {
  const dispatch = useDispatch();
  const reports = useSelector((state) => state.dailyReports.list);
  const { startDate, endDate, filters } = useSelector((state) => state.dailyReports);

  const fetchReports = () => {
    if (!startDate || !endDate) return;
    dispatch(setLoading(true));
    const reportsQuery = query(ref(database, "daily-reports"), orderByKey(), startAt(startDate), endAt(endDate));
    onValue(reportsQuery, (snapshot) => {
      const data = snapshot.val();
      const list = data ? Object.entries(data).map(([date, report]) => ({ date, ...report })) : [];
      dispatch(setFilters(list.length === 0));
      dispatch(setReports(list));
      dispatch(setLoading(false));
    });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchReports();
  };

  // Auto-load with the default date range when the screen opens.
  React.useEffect(() => {
    fetchReports();
  }, []);

  const sum = (kpi) => eur(reports.reduce((acc, r) => acc + (r[kpi] || 0), 0));

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <PageHeader title="Ιστορικό Απολογισμών">
        {reports.length > 0 && !filters ? (
          <FaFilter className="cursor-pointer text-brand-600" onClick={() => dispatch(setFilters(true))} size={22} />
        ) : (
          <FaSearch className="cursor-pointer text-brand-600" onClick={handleSearch} size={22} />
        )}
      </PageHeader>

      <div className="flex-1 overflow-y-auto px-4 pb-24">
        {filters && (
          <DateRangeForm
            startDate={startDate}
            endDate={endDate}
            onStart={(v) => dispatch(setStartDate(v))}
            onEnd={(v) => dispatch(setEndDate(v))}
            onSubmit={handleSearch}
          />
        )}

        {reports.length === 0 ? (
          <NoData />
        ) : (
          <>
            <div className="mb-3 grid grid-cols-3 gap-2 rounded-2xl bg-white p-3 shadow-card">
              <div className="text-center">
                <div className="text-xs text-slate-400">Έσοδα</div>
                <div className="flex items-center justify-center gap-1 font-semibold text-emerald-600">
                  <FaArrowUp size={11} /> {sum("totalIncomes")}
                </div>
              </div>
              <div className="text-center">
                <div className="text-xs text-slate-400">Έξοδα</div>
                <div className="flex items-center justify-center gap-1 font-semibold text-rose-500">
                  <FaArrowDown size={11} /> {sum("totalExpenses")}
                </div>
              </div>
              <div className="text-center">
                <div className="text-xs text-slate-400">Καθαρά</div>
                <div className="font-bold text-brand-700">{sum("total")}</div>
              </div>
            </div>
            <List />
          </>
        )}
      </div>

      <AddDailyReport />
    </div>
  );
};

export default DailyReports;
